import React, { ReactNode } from 'react'
import styled from 'styled-components'

export interface AuthHeadingProps {
  children: ReactNode
  subtitle?: ReactNode
  className?: string
}

export const AuthHeading: React.FC<AuthHeadingProps> = ({
  children,
  subtitle,
  className,
}) => (
  <Wrap className={className}>
    <Title>{children}</Title>
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </Wrap>
)
AuthHeading.displayName = 'AuthHeading'

const Wrap = styled.div`
  margin-bottom: 2.25rem;
`

const Title = styled.h1`
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: 2.125rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  line-height: 1.05;
  margin-bottom: 0.625rem;
  color: ${({ theme }) => theme.colors.ink};

  @media (max-width: 479px) {
    font-size: 1.625rem;
  }
`

const Subtitle = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.ink3};
  line-height: 1.5;
  max-width: 28ch;
`

export default AuthHeading
